<div  method="post" enctype="multipart/form-data" class="inputFile" [ngClass]="{'soloLectura' : disabled}">

  <div class="floatLabel inputPrincipal " >

    <!-- Input -->
    <input id="inputFile{{id}}" [(ngModel)]="archivoNombre" [ngClass]="{'is-filled':input.value, 'inputDeshabilitado' : disabled}" #input="ngModel" type="text" class="form-control soloLectura" required>

    <!-- Título -->
    <label>{{titulo}}</label>

    <!-- Button limpiar --->
    <button class="btnTimes btnActivo" *ngIf="!archivoNombre">
      <svg-icon class="iconoSVG" src="assets/Icono/upload.svg" ></svg-icon>
    </button>

     <!-- Button limpiar --->
    <button class="btnTimes" tabindex="-1" (click)="LimpiarArchivo()" *ngIf="archivoNombre">
      <span class="fa fa-times"></span>
    </button>

    <!-- Mensaje de error -->
    <span [hidden]="!verError || input.valid || (!inputFileTouched && !errorActivo)" class="textoError" >
      {{'SeleccionArchivoIncompleta' | translate}}
    </span>

  </div>

  <!-- Archivo -->
  <input #archivoInput class="selectFileOculto" type="file" id="archivo{{id}}" accept="{{mimeTypeAceptado}}" name="archivo" (change)="SetArchivo($event)" (click)="inputFileTouched = true" data-toggle="tooltip" data-placement="bottom" [ngClass]="{'inputLimpiarEnabled' : archivoNombre}"/>

</div>



